import angular from 'angular'
import { register as registerSwiper } from 'swiper/element/bundle'

import { artsRoutes } from './arts.routes'
import { userArtsService } from './services/user-arts.service'
import { artSizesService } from './services/art-sizes.service'
import { formatsService } from './services/formats.service'
import { socialMediaService } from './services/social-media.service'
import { materialUploadService } from './services/material-upload.service.js'
import { selectMaterialCollectionService } from './services/select-material-collection.service.js'

import { SocialMediaController } from './pages/social-media/social-media.controller'

import { userSearchBar } from './directives/user-search-bar/user-search-bar.directive'
import { generalProperties } from './directives/general-properties/general-properties.directive'
import { publicationProperties } from './directives/publication-properties/publication-properties.directive'
import { customizationProperties } from './directives/customization-properties/customization-properties.directive'
import { onboardingVideoBanner } from './directives/onboarding-video-banner/onboarding-video-banner.directive.js'
import { socialMediaFacebookPreview } from './directives/social-media-facebook-preview/social-media-facebook-preview.directive'
import { socialMediaInstagramPreview } from './directives/social-media-instagram-preview/social-media-instagram-preview.directive'
import { socialMediaStory } from './directives/social-media-story/social-media-story.directive'
import { socialMediaIntegrationBanner } from './directives/social-media-integration-banner/social-media-integration-banner.directive'
import { socialMediaPostPreview } from './directives/social-media-post-preview/social-media-post-preview.directive'
import { floatingBarAdmin } from './directives/floating-bar-admin/floating-bar-admin.directive'
import { floatingBarUser } from './directives/floating-bar-user/floating-bar-user.directive'
import { showMoreArtsButton } from './directives/show-more-arts-button/show-more-arts-button.directive'
import { imageCarousel } from './directives/image-carousel/image-carousel.directive'
import { addMaterialsModal } from './directives/add-materials-modal/add-materials-modal.directive'
import { downloadMaterialsTab } from './directives/download-materials-tab/download-materials-tab.directive'

import { artSizeDialog } from './dialogs/art-size/art-size-dialog.directive'
import { artDownloadProgressDialog } from './dialogs/art-download-progress/art-download-process-dialog.directive'
import { downloadDialog } from './dialogs/download/download-dialog.directive'
import { importDialog } from './dialogs/import/import-dialog.directive'
import { importErrorDialog } from './dialogs/import/import-error/import-error-dialog.directive'
import { templatePropertiesDialog } from './dialogs/template-properties/template-properties-dialog.directive'
import { importTemplateNoCustomizable } from './dialogs/import-template-no-customizable/import-template-no-customizable.directive'
import { shareArtDialog } from './dialogs/share-art/share-art-dialog.directive'
import { shareFolderDialog } from './dialogs/share-folder/share-folder-dialog.directive'
import { socialMediaIntegrationDialog } from './dialogs/social-media-integration/social-media-integration.directive'
import { socialMediaIntegrationUserDialog } from './dialogs/social-media-integration-user/social-media-integration-user.directive'
import { socialMediaLinkedDialog } from './dialogs/social-media-linked/social-media-linked.directive'
import { socialMediaLinkAccountDialog } from './dialogs/social-media-link-account/social-media-link-account.directive'
import { socialMediaPreviewDialog } from './dialogs/social-media-preview/social-media-preview.directive'
import { archiveCollectionsAndTemplatesDialogDirective } from './dialogs/archive-collections-and-templates/archive-collections-and-templates-dialog.directive.js'
import { campaignActionsCarrossel } from './directives/campaign-actions-carrossel/campaign-actions-carrossel.directive'
import { campaignActionMaterialsDialog } from './dialogs/campaign-action-materials/campaign-action-materials-dialog.directive'
import { socialMediaIntegrationUserExpiryDialog } from './dialogs/social-media-integration-user-expiry/social-media-integration-user-expiry.directive'
import { sendToWideDialog } from './dialogs/send-to-wide/send-to-wide-dialog.directive'
import { downloadMessagePublicFolderDialogDirective } from './dialogs/download-message-public-folder/download-message-public-folder-dialog.directive'
import { multipleDownloadDialog } from './dialogs/multiple-download-dialog/multiple-download-dialog.directive'

registerSwiper()

const module = angular
  .module('deskfy.arts', [])
  .config(artsRoutes)
  .factory('ArtSizesService', artSizesService)
  .factory('FormatsService', formatsService)
  .factory('UserArtsService', userArtsService)
  .factory('SocialMediaService', socialMediaService)
  .factory('MaterialUploadService', materialUploadService)
  .factory('SelectMaterialCollectionService', selectMaterialCollectionService)
  .controller('SocialMediaController', SocialMediaController)
  .directive('generalProperties', generalProperties)
  .directive('customizationProperties', customizationProperties)
  .directive('publicationProperties', publicationProperties)
  .directive('importDialog', importDialog)
  .directive('importTemplateNoCustomizable', importTemplateNoCustomizable)
  .directive('artSizeDialog', artSizeDialog)
  .directive('templatePropertiesDialog', templatePropertiesDialog)
  .directive('artDownloadProgressDialog', artDownloadProgressDialog)
  .directive('downloadDialog', downloadDialog)
  .directive('shareArtDialog', shareArtDialog)
  .directive('shareFolderDialog', shareFolderDialog)
  .directive('importErrorDialog', importErrorDialog)
  .directive('userSearchBar', userSearchBar)
  .directive('onboardingVideoBanner', onboardingVideoBanner)
  .directive('socialMediaIntegrationDialog', socialMediaIntegrationDialog)
  .directive('socialMediaIntegrationUserDialog', socialMediaIntegrationUserDialog)
  .directive('socialMediaLinkedDialog', socialMediaLinkedDialog)
  .directive('socialMediaLinkAccountDialog', socialMediaLinkAccountDialog)
  .directive('socialMediaPreviewDialog', socialMediaPreviewDialog)
  .directive('socialMediaFacebookPreview', socialMediaFacebookPreview)
  .directive('socialMediaInstagramPreview', socialMediaInstagramPreview)
  .directive('socialMediaStory', socialMediaStory)
  .directive('socialMediaIntegrationBanner', socialMediaIntegrationBanner)
  .directive('socialMediaPostPreview', socialMediaPostPreview)
  .directive('imageCarousel', imageCarousel)
  .directive('addMaterialsModal', addMaterialsModal)
  .directive('floatingBarAdmin', floatingBarAdmin)
  .directive('floatingBarUser', floatingBarUser)
  .directive('showMoreArtsButton', showMoreArtsButton)
  .directive('archiveCollectionsAndTemplatesDialog', archiveCollectionsAndTemplatesDialogDirective)
  .directive('campaignActionsCarrossel', campaignActionsCarrossel)
  .directive('campaignActionMaterialsDialog', campaignActionMaterialsDialog)
  .directive('socialMediaIntegrationUserExpiryDialog', socialMediaIntegrationUserExpiryDialog)
  .directive('sendToWideDialog', sendToWideDialog)
  .directive('downloadMessagePublicFolderDialog', downloadMessagePublicFolderDialogDirective)
  .directive('downloadMaterialsTab', downloadMaterialsTab)
  .directive('multipleDownloadDialog', multipleDownloadDialog)

export const artModule = module
